const info = state => state.info;

export {
    info
}
